
import { defineComponent } from '@nuxtjs/composition-api'

import { AppointmentLink } from '~/assets/ts/appointment/AppointmentLink'

export default defineComponent({
  components: {},
  setup() {
    /**
     * Appointment
     */

    const appointmentLink = new AppointmentLink().getAppointmentOverview()

    return {
      appointmentLink,
    }
  },
})
